
<template>
  <div class="center-div payment-pageview">
    <div class="center-div payments">
      <div class="creditcard"></div>
      <div class="card">
        <div class="card-content">
          <form action="#">
            <center class="cardInfoW">
              <input
                placeholder="Card Number"
                autocomplete="cc-number"
                v-model="card.number"
                required
                name="cardnumber"
              />
              <input placeholder="CVC" autocomplete="cc-csc" v-model="card.cvc" required name="cvc" />
              <input
                :placeholder="$t('pages.billing.cardholder')"
                autocomplete="cc-name"
                v-model="card.name"
                required
                name="ccname"
              />
              <input
                :placeholder="$t('pages.billing.expirationDate')"
                autocomplete="cc-exp"
                v-model="card.exp"
                required
                name="cc-exp"
              />
            </center>
          </form>
        </div>
        <div class="card-action">
          <button @click="addCard()" class="btn">{{$t('pages.billing.addCard')}}</button>
          <button @click="$root.$router.replace('/rewards')" class="btn">{{$t('generic.cancel')}}</button>
        </div>
      </div>
    </div>

    <v-style>
      .jp-card .jp-card-front .jp-card-lower .jp-card-expiry:before {
      content: "{{$t('pages.billing.monthYear')}}";
      }
    </v-style>
  </div>
</template>

<script>
import stripe from '../../utilities/stripe.js'
import * as ModernModals from 'modern-modals'
export default {
  data() {
    return {
      name: "",
      card: {
        number: '',
        name: '',
        cvc: null,
        exp: ''
      }
    }
  },
  mounted() {
    let _this = this
    new Card({
      form: "form",
      container: ".creditcard",
      masks: {
        cardNumber: "•" // optional - mask card number
      },
      placeholders: {
        number: "•••• •••• •••• 1234",
        name: _this.$t('pages.billing.cardholder'),
        expiry: "MM/YY",
        cvc: "•••"
      },
      formSelectors: {
        numberInput: "input[name='cardnumber']", // optional — default input[name="number"]
        expiryInput: "input[name='cc-exp']", // optional — default input[name="expiry"]
        nameInput: "input[name='ccname']", // optional - defaults input[name="name"]
        cvcInput: 'input[name="cvc"]' // optional — default input[name="cvc"]
      }
    })
  },
  methods: {
    addCard() {
      const localCard = this.$data.card
      stripe.tokenizeCard(localCard).then(cardTokenCode => {
        stripe.addCardToAccount(cardTokenCode).then((data) => {
          gtag('event', 'add_payment_info');
          ModernModals.alert('Success!', `Successfully added card ending in ${data.last4}.`).then(input => this.$router.go(-1))
        }).catch(error => {
          ModernModals.alert('Card Declined!', error.message)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  width: 100%;
}
.jp-card .jp-card-front .jp-card-display,
.jp-card .jp-card-back .jp-card-display {
  color: var(--layout-color);
}
.jp-card .jp-card-front,
.jp-card .jp-card-back {
  background: var(--layout-bg);
}

.payments {
  display: grid;
  grid-gap: 10px;
  grid-template-rows: auto 1fr;
  .card {
    height: unset;
    background: var(--layout-bg);
    &-action {
      display: grid;
      margin-top: 10px;
      grid-gap: 10px;
      grid-template-rows: 1fr 1fr;
    }
  }
}
.payment-pageview {
  background: var(--theme-color);
  grid-template-rows: unset;
  padding-bottom: 35.5px;
}

.cardInfoW {
  position: relative;
  display: grid;
  /* grid-template-columns: 1fr .25fr; */
  grid-template-rows: 1fr 1fr;
  grid-gap: 1.5vh;
}
.bouncefix {
  display: none;
}
</style>
